/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react-hooks/rules-of-hooks */
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  ColumnDef,
  getPaginationRowModel,
} from "@tanstack/react-table";
import { useCallback, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { useBusinessRule } from "~/hooks/businessRule/use-businessRule";
import { PencilIcon } from "@heroicons/react/24/outline";
import CreateRule from "./CreateRule";
import { toast } from "react-toastify"; // Toastify import
import { uploadBusinessRuleFile, downloadBusinessRuleResult } from "~/services/businessRule.services";
import ExcelJS from "exceljs";
import BulkUploadResultModal from "./BulkUploadResultModal";
interface BusinessRule {
  rulename: string;
  status: string;
  condition1_fieldname: string;
  condition1_operator: string;
  condition1_value: string;
  action1_fieldname: string;
  action1_value: string;
  createddate: string;
  businessruleid: string;
}

const BusinessRuleTable = ({
  data,
  fetchData,
}: {
  data: BusinessRule[];
  fetchData: () => void;
}) => {
  const { businessRules, extractionFields } = useBusinessRule();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [openEditModal, setOpenEditModal] = useState(false);
  const [ruleId, setRuleId] = useState<string | null>(null);
  const [filteredData, setFilteredData] = useState<BusinessRule[]>([]);

  const [filters, setFilters] = useState<Record<string, string[]>>({});
  const [searchInputs, setSearchInputs] = useState<Record<string, string>>({});
  const [uploadResultFiles, setUploadResultFiles] = useState([]);
  const [openResultModal, setOpenResultModal] = useState(false)
  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSetFilters = useCallback(
    debounce((value: string, key: string) => {
      setFilters((prev) => ({
        ...prev,
        [key]: [value],
      }));
    }, 0),
    []
  );

  const handleInputChange = useCallback(
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchInputs((prev) => ({
        ...prev,
        [key]: value,
      }));
      debouncedSetFilters(value, key);
    },
    [debouncedSetFilters]
  );

  const checkboxColumn: ColumnDef<any> = {
    id: "select",
    header: ({ table }) => {
      const checkboxRef = useRef<HTMLInputElement>(null);

      useEffect(() => {
        if (checkboxRef.current) {
          const isIndeterminate =
            table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected();
          checkboxRef.current.indeterminate = isIndeterminate;
        }
      }, [table]);

      return (
        <input
          type="checkbox"
          ref={checkboxRef}
          onChange={(e) => {
            table.toggleAllRowsSelected(e.target.checked); // Select all rows
          }}
          checked={table.getIsAllRowsSelected()}
        />
      );
    },

    cell: ({ row }) => (
      <input
        type="checkbox"
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
    enableSorting: false,
    enableHiding: false,
  };

  const editColumn: ColumnDef<any> = {
    id: "edit",
    header: () => <div className="p-2">Edit</div>,
    cell: (props: any) => (
      <div
        className="flex items-center justify-center gap-2 cursor-pointer"
        onClick={() => {
          setRuleId(props.row.original.businessruleid);
          setOpenEditModal(true);
        }}
      >
        <PencilIcon className="h-4 w-4 text-blue-500" />
      </div>
    ),
  };

  const dynamicColumns: ColumnDef<any>[] = (
    businessRules?.viewbusinessrules?.table?.fields || []
  ).map((field: any) => ({
    accessorKey: field.id,
    header: (
      <div className="p-2">
        <div className="flex flex-col gap-2 justify-center">
          <div>{field.label}</div>
          <div className="flex items-center justify-center gap-2">
            <input
              type="text"
              value={searchInputs[field.id] || ""}
              onChange={handleInputChange(field.id)}
              className="border border-gray-300 rounded w-[160px]"
            />
          </div>
        </div>
      </div>
    ),
    cell: (info: { getValue: () => any }) => info.getValue() || "",
  }));

  const columns: ColumnDef<any>[] = [
    checkboxColumn,
    editColumn,
    ...dynamicColumns,
  ];

  const table = useReactTable({
    data: filteredData,
    columns,
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    enableRowSelection: true,
  });

  // const handleExportToExcel = () => {
  //   const selectedRows = table.getSelectedRowModel().rows;

  //   if (selectedRows.length === 0) {
  //     toast.error("No Rows selected", {
  //       theme: "colored",
  //     });
  //     return;
  //   }

  //   const headers = table
  //     .getAllColumns()
  //     .filter(
  //       (col) => col.getIsVisible() && col.id !== "select" && col.id !== "edit"
  //     )
  //     .map((col) => col.columnDef.header as string);

  //   const rows = selectedRows.map((row) => {
  //     const rowData: any = {};
  //     row.getVisibleCells().forEach((cell) => {
  //       const colId = cell.column.id;
  //       if (colId !== "select" && colId !== "edit") {
  //         rowData[colId] = cell.getValue();
  //       }
  //     });
  //     return rowData;
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "BusinessRules");

  //   XLSX.writeFile(workbook, "BusinessRules_Selected.xlsx");
  // };
 const handleExportToExcel = () => {
  const selectedRows = table.getSelectedRowModel().rows;

  if (selectedRows.length === 0) {
    toast.error("No Rows selected", {
      theme: "colored",
    });
    return;
  }

    // Build a list of visible, non-meta columns (excluding checkbox/edit)
  const visibleColumns = table
    .getAllLeafColumns()
    .filter(
      (col) => col.getIsVisible() && col.id !== "select" && col.id !== "edit"
    );

  
    // Build rows: match keys to values using column IDs
  const rows = selectedRows.map((row) => {
    const rowData: Record<string, any> = {};
    visibleColumns.forEach((col) => {
      rowData[col.id] = row.getValue(col.id);
    });
    return rowData;
  });
  
    // Use worksheet with defined headers
  const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.sheet_add_aoa(worksheet, [businessRules?.viewbusinessrules?.table?.fields.map((h: { label: string}) => h.label)], {
      origin: "A1",
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "BusinessRules");

  XLSX.writeFile(workbook, "BusinessRules_Selected.xlsx");
};

const handleDownloadTemplate = async () => {
 let operators: any = [];
 const fields = extractionFields.data.reduce((acc: [string], item: any) => {
      operators.push(...item.businessruleoperator.split(","))
      acc.push(item.fieldname);
      return acc
  }, []);
  operators = [...new Set(operators)]
  const headers = [
    "Condition 1: Field", "op.1", "Value.1", "conc.1",
    "Condition 2: Field", "op.2", "Value.2", "conc.2",
    "Condition 3: Field", "op.3", "Value.3", "conc.3",
    "Condition 4: Field", "op.4", "Value.4",
    "THEN",
    "Output 1: Field", "Value 1", "conc. 1",
    "Output 2: Field", "Value 2", "conc. 2",
    "Output 3: Field", "Value 3", "conc. 3",
    "Output 4: Field", "Value 4"
  ];

  const dropdownOptionsByHeader: any = {
    "Condition 1: Field": fields,
    "Condition 2: Field": fields,
    "Condition 3: Field": fields,
    "Condition 4: Field": fields,
    "Output 1: Field": fields,
    "Output 2: Field": fields,
    "Output 3: Field": fields,
    "Output 4: Field": fields,
    "op.1": operators,
    "op.2": operators,
    "op.3": operators,
    "op.4": operators
  };

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Template");

  worksheet.addRow(headers);

  const totalRows = 2000;

  for (let rowIndex = 2; rowIndex <= totalRows + 1; rowIndex++) {
    for (let colIndex = 1; colIndex <= headers.length; colIndex++) {
      const header = headers[colIndex - 1];
      const options = dropdownOptionsByHeader[header];

      if (options && options.length > 0) {
        worksheet.getCell(rowIndex, colIndex).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [`"${options.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Invalid Option",
          error: "Select a valid option from the dropdown",
        };
      }
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "businessrules_template.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};



const readFileAsBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        resolve(result.split(",")[1] || result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

 const handleFileUpload = async (e: any) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    alert("Please upload a valid XLSX file.");
    return;
   }

   const base64Content = await readFileAsBase64(file);
    await uploadBusinessRuleFile(base64Content);
  };

 const listBulkUploadResults = async () => {
    const {data}: any = await downloadBusinessRuleResult();
    setUploadResultFiles(data?.data);
    setOpenResultModal(true)
  };

  useEffect(() => {
      const filtered = data.filter((row: any) =>
        Object.entries(filters).every(([key, searchValues]) => {
          const values = Array.isArray(searchValues)
            ? searchValues
            : [searchValues];
          return values.some((value) => {
            return row[key]
              ?.toString()
              .toLowerCase()
              .includes(value.toLowerCase());
          });
        })
      );
      setFilteredData(filtered);
      table.setPageIndex(0);
      table.resetRowSelection()
    }, [filters, data]);
    
  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4">
        <div>
          <label>
            Rows per page:
            <select
              className="border rounded p-1 pr-6"
              value={
                pagination.pageSize ===
                table.getPrePaginationRowModel().rows.length
                  ? "all"
                  : pagination.pageSize
              }
              onChange={(e) => {
                const value = e.target.value;
                table.setPageSize(
                  value === "all"
                    ? table.getPrePaginationRowModel().rows.length
                    : Number(value)
                );
              }}
            >
              {[5, 10, 20, 30, 40, 50].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
              <option value="all">All</option>
            </select>
          </label>
        </div>

        <div className="flex space-x-2">
          <button
            onClick={handleDownloadTemplate}
            className="bg-orange-400 text-white py-1 px-2 rounded"
          >
            Download Template
          </button>
          <label className="bg-orange-400 text-white py-2 px-4 rounded mr-1">
              Upload file
              <input
                type="file"
                onChange={handleFileUpload}
                className="hidden"
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"              />
            </label>
            <label className="bg-orange-400 text-white py-2 px-4 rounded mr-1">
              View Upload Result
              <input
                onClick={listBulkUploadResults}
                className="hidden"
              />
            </label>
          <button
            onClick={handleExportToExcel}
            className="bg-orange-400 text-white py-1 px-2 rounded"
          >
            Export to Excel
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="w-full overflow-x-scroll">
        <table
          style={{ tableLayout: "fixed" }}
          className="min-w-full divide-y divide-gray-200"
        >
          <thead className="bg-gray-50 text-nowrap sticky top-0 z-10">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} className="p-2 text-sm">
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-50 text-md">
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="p-2 border text-sm">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-4">
        <div className="text-sm font-medium">
          Showing {table.getRowModel().rows.length} of{" "}
          {table.getPrePaginationRowModel().rows.length} entries
        </div>
        <div className="flex items-center gap-4 mt-4">
          <button
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
            className="px-4 py-1 border rounded"
          >
            Previous
          </button>
          <span className="text-sm">
            Page {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </span>
          <button
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
            className="px-4 py-1 border rounded"
          >
            Next
          </button>
        </div>
      </div>

      {/* Edit Modal */}
      {openEditModal && (
        <CreateRule
          closeModal={() => {
            fetchData();
            setOpenEditModal(false);
            setRuleId(null);
          }}
          type="edit"
          ruleId={ruleId}
        />
      )}
       <BulkUploadResultModal
                isOpen={openResultModal}
                onClose={() => setOpenResultModal(false)}
                documents={uploadResultFiles}
      />
    </div>
  );
};

export default BusinessRuleTable;
